'use strict';

import {HodnotenieSSItem} from './HodnotenieSsItem';

export class HodnotenieSS {
  id: number;
  predmetSkratka: string;
  predmetNazov: string;
  type: string;
  hodnotenia: HodnotenieSSItem[];
}
